'use client';

import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { MemberZoneNotLogged } from './member-zone-not-logged';
import { MemberZoneLogged } from './member-zone-logged';

export function MemberZoneRouter() {
  const me = useCustomerStore(s => s.me);

  const hasSubscription = me?.customer?.active_subscriptions?.length > 0;

  console.log(me?.customer);

  if (!me || !hasSubscription) return <MemberZoneNotLogged />;

  return <MemberZoneLogged />;
}
